/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionForceUpdate';

const ActionForceUpdateManager: ActionManagerFn<'ActionForceUpdate'> = (
  platform: Platform,
): ActionManager<'ActionForceUpdate'> => {
  return {
    ...baseActionManager(platform, 'ActionForceUpdate'),
    defaultValue,
    props: {
      ...baseActionProps,
    },
    name: 'Force Update',
    icon: { iconName: 'save' },
    description: `**Overview**<br/>
The Force Update action is a technical utility component designed to explicitly trigger a state update cycle within the application's runtime. It functions as a synchronization checkpoint, allowing developers to manually compel the system to process pending state changes or refresh the execution context at a specific moment.<br/><br/>
This component is structurally minimal, leveraging the platform's standard action infrastructure without introducing any specific configuration parameters. It is intended for advanced logic flows where standard automatic state batching might obscure intermediate updates that need to be recognized before the next action in a sequence begins.

**Key Features**<br/>
* **Zero-Configuration:** Built directly on baseActionManager and baseActionProps with no additional properties, making it a simple "drop-in" trigger.
* **State Synchronization:** Explicitly defined to "force update the state in between actions," ensuring that any modifications made by preceding actions are fully propagated before subsequent logic executes.

**Properties**<br/>
* **Base Properties:** This component utilizes ...baseActionProps exclusively, accepting only the standard configuration options available to all actions.

**Use Cases**<br/>
* **Action Chaining:** Ensuring that a variable update is fully processed and available to a dependent action later in the same sequence.
* **UI Refresh:** Forcing a re-render to update the interface in the middle of a complex workflow where automatic updates might be batched or delayed.`,
  };
};

export default ActionForceUpdateManager;
